import { hbs } from 'ember-cli-htmlbars';
export default hbs("<SiteWrapper::Breadcrumb\n  @label={{t \'Manage templates\'}}\n  @route=\'routes/reports.kpi-compare.manage-templates\'\n/>\n\n<Page::KpiCompareReport::ManageTemplates />")